import { showTitle } from '_u/helper'

export default {
    methods: {
        showTitle(item) {
            return showTitle(item, this)
        },
        showChildren(item) {
            return item.children && (item.children.length > 1 || (item.meta && item.meta.showAlways))
        },
        getName(item, children0) {
            return children0 ? item.children[0].name : item.name
        },
    }
}
